export default "__VITE_ASSET__c5083c06__"